import config from "@/utils/config";
import http from "./request";
import newHttp from "./http";
import api from "./api";

//获取本地缓存的token
export const getToken = () => {
  let token = localStorage.getItem("token") || config.TOKEN || null;
  return token;
};

export function isIos() {
  var agent = navigator.userAgent.toLowerCase();
  var iphone = agent.indexOf("iphone");
  var ipad = agent.indexOf("ipad");
  if (iphone != -1 || ipad != -1) {
    return true;
  } else {
    return false;
  }
}

export function getPc() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    var ua = navigator.userAgent.toLowerCase();
    var isWxWork = ua.indexOf("wxwork") != -1;
    var isWeixin = ua.indexOf("micromessenger") != -1 && !isWxWork;
    var iosVer = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (iosVer) iosVer = parseInt(iosVer[1], 10);
    if (isWeixin) {
      // 还要判断ios和安卓版本。。。
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      if (
        compareVersion(wechatInfo[1], "7.0.14") == 1 &&
        ((iosVer && iosVer > 11) || !iosVer)
      ) {
        return 2;
      }
      return 3;
    } else {
      return 1;
    }
  } else {
    // pc
    return 0;
  }
}

export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger" && ua.match(/wxwork/i) != "wxwork") {
    return true;
  } else {
    return false;
  }
}

export function isWxWork() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/wxwork/i) == "wxwork") {
    return true;
  } else {
    return false;
  }
}

export const PC_LOGIN_REQUIRED_EVENT = "xqd:pc-login-required";

// 登录成功后初始化知你客服。
export const initZhiniCustomer = (userInfo = {}) => {
  console.log('userInfo',userInfo)
  if (typeof window === "undefined" || typeof window._ZHINI !== "function") {
    return;
  }
  if (!userInfo.openid) {
    return;
  }
  window._ZHINI({
    action: "init",
    client_id: userInfo.openid,
    name: userInfo.uname,
    avatar: userInfo.upic,
  });
};

// 打开知你客服面板。
export const showZhiniCustomerPanel = () => {
  if (typeof window === "undefined" || typeof window._ZHINI !== "function") {
    return;
  }
  window._ZHINI({ action: "showPanel" });
};

export const isWechatMobileEnv = () => {
  const pcType = getPc();
  return pcType == 2 || pcType == 3;
};

export const isPcBrowserEnv = () => {
  return getPc() == 0;
};

export const triggerLoginFlow = (options = {}) => {
  const { onPcLogin } = options;
  // 登录入口统一分流：
  // PC 浏览器走扫码（由页面决定如何展示弹窗），手机微信环境走网页授权。
  if (isPcBrowserEnv()) {
    if (typeof onPcLogin === "function") {
      onPcLogin();
    } else if (typeof window !== "undefined") {
      window.dispatchEvent(new Event(PC_LOGIN_REQUIRED_EVENT));
    }
    return Promise.resolve("pc");
  }

  if (isWechatMobileEnv()) {
    return wxLogin();
  }

  return Promise.resolve("skip");
};

const isPcOpenSdkReady = () => {
  return typeof window !== "undefined" &&
    window.wxopensdk &&
    window.wxopensdk.ready &&
    typeof window.wxopensdk.launchMiniProgram === "function";
};

const PC_OPENSDK_LAUNCH_TIMEOUT = 2500;
const PC_OPENSDK_FAIL_COOLDOWN = 60 * 1000;
let pcOpenSdkFailUntil = 0;
let pcOpenSdkLaunchingPromise = null;

const withTimeout = (promise, timeoutMs, timeoutReason = "timeout") => {
  return new Promise((resolve, reject) => {
    let settled = false;
    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      const err = new Error(timeoutReason);
      err.code = timeoutReason;
      reject(err);
    }, timeoutMs);

    Promise.resolve(promise).then((value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(value);
    }).catch((error) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      reject(error);
    });
  });
};

const getPcOpenSdkTicket = (token) => {
  // 兼容后端不同参数命名：同时传 token 与 access_token。
  return http.get(api.checkin.pcTicket, {
    token,
    access_token: token,
  }).then((res) => {
    const ticket = res && res.data && res.data.ticket ? String(res.data.ticket) : "";
    if (!ticket) {
      return Promise.reject(new Error("EMPTY_TICKET"));
    }
    return ticket;
  });
};

export const tryLaunchMiniProgramOnPc = (options = {}) => {
  const {
    token = getToken(),
    path = "",
  } = options;

  if (!isPcBrowserEnv()) {
    return Promise.resolve({ handled: false, launched: false, reason: "not_pc_browser" });
  }
  if (!token) {
    return Promise.resolve({ handled: false, launched: false, reason: "no_token" });
  }
  if (!path) {
    return Promise.resolve({ handled: false, launched: false, reason: "missing_path" });
  }
  if (!isPcOpenSdkReady()) {
    return Promise.resolve({ handled: false, launched: false, reason: "sdk_not_ready" });
  }
  if (pcOpenSdkLaunchingPromise) {
    // 防止同一时刻重复触发多次端口探测请求。
    return pcOpenSdkLaunchingPromise;
  }
  if (Date.now() < pcOpenSdkFailUntil) {
    // 上一次拉起失败后短时间内不再反复探测本地端口，直接走页面兜底逻辑。
    return Promise.resolve({ handled: true, launched: false, reason: "cooldown_active" });
  }

  pcOpenSdkLaunchingPromise = getPcOpenSdkTicket(token).then((ticket) => {
    const payload = {
      appid: 'wx89a319fa8b0a9ea4',
      userName: 'gh_eedd8c096654',
      path,
      ticket,
    };
    return withTimeout(
      window.wxopensdk.launchMiniProgram(payload),
      PC_OPENSDK_LAUNCH_TIMEOUT,
      "launch_timeout"
    ).then((result) => {
      if (result && Number(result.errcode) === 0) {
        pcOpenSdkFailUntil = 0;
        return { handled: true, launched: true, result };
      }
      pcOpenSdkFailUntil = Date.now() + PC_OPENSDK_FAIL_COOLDOWN;
      console.error("[PC OpenSDK] launchMiniProgram failed response:", result);
      return { handled: true, launched: false, reason: "launch_failed", result };
    }).catch((error) => {
      pcOpenSdkFailUntil = Date.now() + PC_OPENSDK_FAIL_COOLDOWN;
      console.error("[PC OpenSDK] launchMiniProgram threw error:", error);
      return { handled: true, launched: false, reason: "launch_exception", error };
    });
  }).catch((error) => {
    pcOpenSdkFailUntil = Date.now() + PC_OPENSDK_FAIL_COOLDOWN;
    console.error("[PC OpenSDK] get ticket failed:", error);
    return { handled: true, launched: false, reason: "ticket_failed", error };
  }).then((state) => {
    if (!state || state.launched) {
      return state;
    }
    console.warn("[PC OpenSDK] launch not completed:", state.reason || "unknown_reason", state);
    return state;
  }).finally(() => {
    pcOpenSdkLaunchingPromise = null;
  });
  return pcOpenSdkLaunchingPromise;
};
export function isMobile() {
  var ua = navigator.userAgent.toLowerCase();
  var bIsIpad = ua.match(/ipad/i) == "ipad";
  var bIsIphoneOs = ua.match(/iphone os/i) == "iphone os";
  var bIsMidp = ua.match(/midp/i) == "midp";
  var bIsUc7 = ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = ua.match(/ucweb/i) == "ucweb";
  var bIsAndroid = ua.match(/android/i) == "android";
  var bIsCE = ua.match(/windows ce/i) == "windows ce";
  var bIsWM = ua.match(/windows mobile/i) == "windows mobile";
  if (
    !(
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM
    )
  ) {
    return false;
  } else return true;
}
export function isUnionPay() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/UnionPay/i) == "unionpay") {
    return true;
  } else {
    return false;
  }
}

export function compareVersion(v1, v2) {
  v1 = v1.split(".");
  v2 = v2.split(".");
  var len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }
  for (var i = 0; i < len; i++) {
    var num1 = v1[i];
    var num2 = v2[i];
    let max = Math.max(num1.length, num2.length);
    num1 = Math.pow(10, max - num1.length + 1) * num1;
    num2 = Math.pow(10, max - num2.length + 1) * num2;
    if (num1 * 1 > num2 * 1) {
      return 1;
    } else if (num1 * 1 < num2 * 1) {
      return -1;
    }
  }
  return 0;
}

var jumping = false;
export const jumpWxAuth = () => {
  return triggerLoginFlow();
};

// 使用微信浏览器网页授权登录（支持手机微信与桌面微信内置浏览器）
export const wxLogin = () => {
  return new Promise((resolve, reject) => {
    if (isWxWork()) {
      resolve("skip");
      return;
    }
    if (!isWeixin()) {
      if (isPcBrowserEnv() && typeof window !== "undefined") {
        window.dispatchEvent(new Event(PC_LOGIN_REQUIRED_EVENT));
        resolve("pc");
        return;
      }
      resolve("skip");
      return;
    }
    if (jumping) {
      resolve("pending");
      return;
    }
    jumping = true;
    const currentUrl = window.location.href;
    let url = urlencode(currentUrl);
    const code = getQueryString("code");
    if (!code) {
      const authUrl = config.wx_auth_url
        .replace("#{{appid}}", getAppid())
        .replace("#{{url}}", url);
      jumping = false;
      window.location.href = authUrl;
    } else {
      let parm = { code: code, source: "h5_temp" };
      newHttp
        .post("/xcx/checkin_web/v1/login", parm)
        .then((res) => {
          jumping = false;
          localStorage.setItem("token", res.data.access_token);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          initZhiniCustomer(res.data);
          resolve();
        })
        .catch((err) => {
          // 登录失败时必须重置 jumping，避免后续登录入口被锁死。
          jumping = false;
          reject(err);
        });
    }
  });
};

export const configApi = (success, error) => {
  let parm = {
    access_token: "",
    url: window.location.href.split("#")[0],
    source: "h5",
  };
  http
    .post("/xcx/checkin_web/v1/sign", parm)
    .then((res) => {
      if (res.sta == 0) {
        wx.config({
          debug: false,
          appId: getAppid(),
          timestamp: res.data.timestamp,
          nonceStr: res.data.noncestr,
          signature: res.data.sign,
          jsApiList: [
            "chooseWXPay",
            "wx-open-launch-weapp",
            "wx.previewImage",
            "getLocation",
            "chooseImage",
            "chooseMessageFile",
          ],
          openTagList: ["wx-open-launch-weapp"],
        });
        wx.ready(function() {
          localStorage.setItem("WX_SDK_OK", true);
          success && success();
        });
        wx.error(function(res) {
          localStorage.setItem("WX_SDK_OK", false);
          error && error(res);
        });
      }
    })
    .catch(function(errors) {});
};

//判断是否为空字符
export const isTextEmpty = (text) => {
  text = text + "";
  return text && text != "undefined" ? text.trim().length == 0 : true;
};

export function urlencode(str) {
  str = (str + "").toString();
  return encodeURIComponent(str)
    .replace(/!/g, "%21")
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/\*/g, "%2A")
    .replace(/%20/g, "+");
}

function getAppid() {
  return config.appid;
}

export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    var parm = unescape(r[2]);
    if (parm.indexOf(" ") > -1) {
      parm = parm.replace(/\s+/g, "");
    }
    return parm;
  } else return null;
};

//时间戳转日期 年月日
export const formatDateTime = (inputTime, type) => {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  //return y + '-' + m + '-' + d;

  if (type == 1) {
    return m + "/" + d + " " + h + ":" + minute;
  } else if (type == 2) {
    return y + "-" + m + "-" + d + " " + h + ":" + minute;
  } else {
    return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  }
};

export const formatDate = (source, format) => {
  source = isNaN(source) ? source : new Date(source);
  var o = {
    "M+": source.getMonth() + 1, // 月份
    "d+": source.getDate(), // 日
    "H+": source.getHours(), // 小时
    "m+": source.getMinutes(), // 分
    "s+": source.getSeconds(), // 秒
    "q+": Math.floor((source.getMonth() + 3) / 3), // 季度
    "f+": source.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (source.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
};

export const getTimeString = (timeInSeconds) => {
  var hour = Math.floor(timeInSeconds / 60 / 60);
  if (hour < 10) {
    hour = "0" + hour;
  }
  var minute = Math.floor((timeInSeconds - hour * 60 * 60) / 60);
  if (minute < 10) {
    minute = "0" + minute;
  }
  return hour + ":" + minute;
};

//获取地理
export const getDistance = (lng1, lat1, lng2, lat2) => {
  var radLat1 = rad(lat1);
  var radLat2 = rad(lat2);
  var a = radLat1 - radLat2;
  var b = rad(lng1) - rad(lng2);
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137; //地球半径
  s = Math.round(s * 10000) / 10;
  return s;
};
function rad(d) {
  return (d * Math.PI) / 180.0;
}

// 获取秒数
export const getUTCDateInSeconds = (dateString) => {
  try {
    var dateSplit = dateString.split("-");
    var date = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2], 0, 0, 0);
    return date.getTime() / 1000;
  } catch (err) {
    return 0;
  }
};

export const getDaysLater = (days, date) => {
  if (date) {
    var today = new Date(date);
    return new Date(today.valueOf() + 24 * 60 * 60 * 1000 * days);
  } else {
    var today = new Date();
    return new Date(today.valueOf() + 24 * 60 * 60 * 1000 * days);
  }
};

export const hasSensitiveWords = (str) => {
  if (str == "" || str == undefined) return false;
  var words =
    "国办发,中办发,腐败中国,三个呆婊,社会主义灭亡,打倒中国,灭亡中国,亡党亡国,粉碎四人帮,激流中国,特共,zf大楼,殃视,红色贵族,河蟹社会,喝血社会,九风,9风,十7大,17da,四风,4风,南街村,最淫官员,警匪,官匪,独夫民贼,官商勾结,城管暴力执法,强制捐款,毒豺,一党专政,专制政权,苏晓康,贺卫方,谭作人,焦国标,万润南,张志新,辛灝年,高勤荣,王炳章,高智晟,司马璐,刘晓竹,刘宾雁,魏京生,寻找林昭的灵魂,别梦成灰,讨伐中宣部,异议人士,民一主,min主,民竹,民珠,民猪,chinesedemocracy,大赦国际,国际特赦,da选,投公,公头,宪政,昝爱宗,08宪,08xz,抿主,敏主,人拳,人木又,人quan,renquan,中国的人权,中国新民党,shangfang,静坐,静zuo,jing坐,示威,示wei,游行,you行,油行,游xing,youxing,官逼民反,反party,抗议,亢议,低制,底制,di制,抵zhi,dizhi,boycott,血书,焚烧中国国旗,baoluan,流血冲突,出现暴动,发生暴动,引起暴动,baodong,灭共,杀毙,霸工,罢考,罢餐,霸餐,罢参,罢饭,罢吃,罢食,罢课,罢ke,霸课,ba课,罢教,罢学,罢运,网特,五毛党,五毛们,5毛党,jieyan,jie严,戒yan,8的平方事件,知道64,八九年,贰拾年,2o年,20和谐年,贰拾周年,六河蟹四,六百度四,六和谐四,陆四,陆肆,198964,5月35,89年春夏之交,64惨案,64时期,64运动,4事件,四事件,北京风波,学潮,学chao,xuechao,学百度潮,门安天,天按门,坦克压大学生,历史的伤口,高自联,北高联,thegateofheavenlypeace,bloodisonthesquare,为了忘却的纪念,血洗京城,四二六社论,封从德,王超华,王维林,吾尔开希,吾尔开西,侯德健,阎明复,方励之,蒋捷连,丁子霖,辛灏年,蒋彦永,严家其,陈一咨,中华局域网,党的喉舌,互联网审查,当局严密封锁,新闻封锁,爱国者同盟,关闭所有论坛,网络封锁,金盾工程,gfw,无界浏览,无界网络,自由门,何清涟,中国的陷阱,汪兆钧,记者无疆界,境外媒体,世界日报,东森新闻网,东森电视,基督教科学箴言报,星岛日报,雅虎香港,googleblogger,美国之音,自由亚洲,自由时报,中国时报,反分裂,威胁论,左翼联盟,保钓组织,弓单,火乍,木仓,石肖,核蛋,步qiang,bao炸,爆zha,baozha,zha药,zha弹,炸dan,炸yao,zhadan,zhayao,hmtd,三硝基甲苯,六氟化铀,炸药配方,弹药配方,炸弹配方,皮箱炸弹,火药配方,人体炸弹,人肉炸弹,兵力部署,军转,军事社,8341部队,第21集团军,七大军区,7大军区,北京军区,沈阳军区,济南军区,成都军区,广州军区,南京军区,兰州军区,颜色革命,规模冲突,塔利班,基地组织,恐怖分子,恐怖份子,三股势力,印尼屠华,印尼事件,蒋公纪念歌,mayingjiu,李天羽,苏贞昌,林文漪,陈s扁,陈随便,阿扁,a扁,告全国同胞书,台百度湾,台完,台wan,台弯,湾台,台湾国,台湾共和国,台军,台独,台毒,台du,taidu,twdl,一中一台,打台湾,两岸关系,两岸战争,攻占台湾,支持台湾,进攻台湾,占领台湾,统一台湾,收复台湾,登陆台湾,解放tw,解决台湾,光复民国,台湾独立,台海问题,台海危机,台海统一,台海大战,台海战争,台海局势,入联,入耳关,中华联邦,x民党,民进党,青天白日,闹独立,fenlie,日本万岁,小泽一郎,劣等民族,汉维,维汉,热比娅,疆独,东突厥斯坦解放组织,东突解放组织,蒙古分裂分子,列确,阿旺晋美,臧人,zang人,藏民,藏m,达赖,赖达,dalai,哒赖,dl喇嘛,丹增嘉措,打砸抢,西独,藏独,葬独,臧独,藏毒,藏du,zangdu,支持zd,藏暴乱,藏青会,雪山狮子旗,啦萨,啦沙,啦撒,拉sa,lasa,la萨,藏西,xizang,xi藏,x藏,西z,tibet,希葬,希藏,硒藏,稀藏,西脏,西奘,西葬,西臧,援藏,bjork,王千源,安拉,回教,回回,穆斯林,穆罕穆德,穆罕默德,默罕默德,伊斯兰,圣战组织,清zhen,qingzhen,真主,高丽棒子,韩国狗,满洲第三帝国,满狗,鞑子,胡的接班人,张培莉,温云松,温如春,温jb,胡温,胡x,胡jt,胡boss,胡总,胡王八,hujintao,胡jintao,胡j涛,胡惊涛,胡景涛,胡紧掏,湖紧掏,胡紧套,hjt,胡派,刘永清,胡海峰,胡海清,民泽江,江胡,江哥,江主席,江浙闽,江沢民,江浙民,择民,则民,茳泽民,ze民,老江,老j,江core,江x,江派,江zm,江戏子,江蛤蟆,江某某,江贼,江猪,平小邓,xiao平,邓xp,邓晓平,邓朴方,邓榕,邓质方,猫泽东,猫则东,chairmanmao,猫贼洞,毛zd,毛zx,z东,ze东,泽d,zedong,毛太祖,毛相,朱镕鸡,朱容鸡,李peng,里鹏,李月月鸟,华主席,薄熙来,薄一波,蔡赴朝,华建敏,吕祖善,马飚,孟建柱,欧广源,强卫,粟戎生,铁凝,屠光绍,大陆当局,中国当局,北京当局,共贪党,gongchandang,阿共,共一产一党,公产党,工产党,共c党,共铲,供产,共惨,供铲党,供铲谠,供铲裆,共残党,共残主义,共产主义的幽灵,拱铲,老共,中珙,狗产蛋,共残裆,恶党,邪党,共产专制,共产王朝,裆中央,土共,土g,共狗,g匪,共匪,仇共,communistparty,症腐,政俯,政一府,政百度府,政f,zhengfu,政zhi,国wu院,中华帝国,gong和,大陆官方,北京政权,,福音会,中国教徒,统一教,观音法门,清海无上师,李洪志,志洪李,李宏志,轮法功,三去车仑,氵去车仑,发论工,法x功,法o功,法0功,法一轮一功,轮子功,车仑工力,法lun,fa轮,法lg,fl功,falungong,大法弟子,大纪元,dajiyuan,明慧网,明慧周报,正见网,新唐人,伪火,退党,tuidang,退dang,超越红墙,自fen,真善忍,九评,9评,9ping,九ping,藏字石,集体自杀,自sha,zi杀,suicide,titor,逢8必灾,逢八必灾,逢9必乱,逢九必乱,朱瑟里诺,根达亚文明,诺查丹玛斯,人类灭亡进程表,按照马雅历法,推背图,推bei图,济世灵文,诸世纪,爱女人,爱液,按摩棒,拔出来,爆草,包二奶,暴干,暴奸,暴乳,爆乳,暴淫,屄,被操,被插,被干,逼奸,仓井空,插暴,操逼,操黑,操烂,肏你,肏死,操死,操我,厕奴,插比,插b,插逼,插进,插你,插我,插阴,潮吹,潮喷,成人电影,成人论坛,成人色情,成人网站,成人文学,成人小说,艳情小说,成人游戏,吃精,赤裸,抽插,扌由插,抽一插,春药,大波,大力抽送,大乳,荡妇,荡女,盗撮,多人轮,发浪,放尿,肥逼,粉穴,封面女郎,风月大陆,干死你,干穴,肛交,肛门,龟头,裹本,国产av,好嫩,豪乳,黑逼,后庭,后穴,虎骑,花花公子,换妻俱乐部,黄片,几吧,鸡吧,鸡巴,鸡奸,寂寞男,寂寞女,妓女,集体淫,奸情,叫床,脚交,精液,就去日,巨屌,菊花洞,菊门,巨奶,巨乳,菊穴,开苞,口爆,口活,口交,口射,口淫,裤袜,狂操,狂插,浪逼,浪妇,浪叫,浪女,狼友,聊性,流淫,铃木麻,凌辱,漏乳,露b,乱交,乱伦,轮暴,轮操,轮奸,裸陪,买春,美逼,美少妇,美乳,美腿,美穴,美幼,秘唇,迷奸,密穴,蜜穴,蜜液,摸奶,摸胸,母奸,奈美,奶子,男奴,内射,嫩逼,嫩女,嫩穴,捏弄,女优,炮友,砲友,喷精,屁眼,品香堂,前凸后翘,强jian,强暴,强奸处女,情趣用品,情色,拳交,全裸,惹火身材,人妻,人兽,日逼,日烂,肉棒,肉逼,肉唇,肉洞,肉缝,肉棍,肉茎,肉具,揉乳,肉穴,肉欲,乳爆,乳房,乳沟,乳交,乳头,三级片,骚逼,骚比,骚女,骚水,骚穴,色逼,色界,色猫,色盟,色情网站,色区,色色,色诱,色欲,色b,少年阿宾,少修正,射爽,射颜,食精,释欲,兽奸,兽交,手淫,兽欲,熟妇,熟母,熟女,爽片,爽死我了,双臀,死逼,丝袜,丝诱,松岛枫,酥痒,汤加丽,套弄,体奸,体位,舔脚,舔阴,调教,偷欢,偷拍,推油,脱内裤,文做,我就色,无码,舞女,无修正,吸精,夏川纯,相奸,小逼,校鸡,小穴,小xue,性感妖娆,性感诱惑,性虎,性饥渴,性技巧,性交,性奴,性虐,性息,性欲,胸推,穴口,学生妹,穴图,亚情,颜射,阳具,要射了,夜勤病栋,一本道,一夜欢,一夜情,一ye情,阴部,淫虫,阴唇,淫荡,阴道,淫电影,阴阜,淫妇,淫河,阴核,阴户,淫贱,淫叫,淫教师,阴茎,阴精,淫浪,淫媚,淫糜,淫魔,淫母,淫女,淫虐,淫妻,淫情,淫色,淫声浪语,淫兽学园,淫书,淫术炼金士,淫水,淫娃,淫威,淫亵,淫样,淫液,淫照,阴b,应召,幼交,幼男,幼女,欲火,欲女,玉女心经,玉蒲团,玉乳,欲仙欲死,玉穴,援交,原味内衣,援助交际,招鸡,招妓,中年美妇,抓胸,自慰,作爱,18禁,99bb,a4u,a4y,adult,amateur,anal,a片,fuck,gay片,g点,g片,hardcore,h动画,h动漫,porn,secom,sexinsex,sm女王,xiao77,xing伴侣,tokyohot,yin荡,汉芯造假,杨树宽,中印边界谈判结果,喂奶门,摸nai门,酒瓶门,脱裤门,75事件,新疆骚乱,针刺,打针,食堂涨价,饭菜涨价,h1n1,瘟疫爆发,yangjia,y佳,yang佳,杨j,袭警,杀警,武侯祠,川b26931,贺立旗,周正毅,px项目,骂四川,家l福,家le福,加了服,麦当劳被砸,这不是天灾,龙小霞,震其国土,yuce,隐瞒地震,李四光预测,蟾蜍迁徙,地震来得更猛烈,八级地震毫无预报,踩踏事故,聂树斌,万里大造林,陈相贵,张丹红,尹方明,李树菲,王奉友,零八奥运艰,惨奥,奥晕,凹晕,懊运,懊孕,奥孕,奥你妈的运,反奥,628事件,weng安,wengan,翁安,瓮安事件,化工厂爆炸,讨回工资,太子党,联名上书,讨说法,信访厅,信访处,截访,上访,访民,刷单,返现,返款,接任务,空投";
  var array = words.split(","),
    len = array.length;
  for (var i = 0; i < len; i++) {
    var item = array[i];
    if (str.indexOf(item) >= 0 && item != "") {
      return item;
    }
  }
  return false;
};

export const replaceAll = (oldStr, reStr) => {
  var len = reStr.length,
    starStr = "";
  for (var i = 0; i < len; i++) {
    starStr += "*";
  }
  return oldStr.replace(new RegExp(reStr, "gm"), starStr);
};

export const getAndroidMiniPath = (template, cid) => {
  let url = "";
  if (template == 0) url = "/pages/detail/detail.html";
  if (template == 1) url = "/pages/detailmeeting/detailmeeting.html";
  if (template == 2) url = "/pages/detailwork/detailwork.html";
  url += `?cid=${cid}`;
  return url;
};



// WEBPACK FOOTER //
// ./src/utils/common.js